<!-- SMT 新客现金券活动 -->
<template>
  <div v-if="isShow" class="voucher_ad">
    <div v-if="isClaim" class="voucher_ad__claimed">
      <div class="voucher_ad__claimed__close">
        <img src="@@/assets/img/smt/activity/smt_voucher_close1.png" alt="" @click="handleCloseNone">
      </div>
      <div class="voucher_ad__claimed__success">
        <img src="@@/assets/img/smt/activity/smt_voucher_success.png" alt="" >
      </div>
      <div class="voucher_ad__claimed__text">
        600元SMT现金券已到账
      </div>
      <div class="voucher_ad__claimed__desc">
        现金券已发放至您的账户，可在SMT订单中使用
      </div>
      <div class="voucher_ad__claimed__btns">
        <span target="_blank" class="secondary-btn" @click="handleViewVoucher">
          查看我的现金券
        </span>
        <span target="_blank" class="primary-btn" @click="handleQuoteSmt">
          去下SMT订单
        </span>
      </div>
    </div>
    <div v-else class="voucher_ad__content">
      <img src="@@/assets/img/smt/activity/smt_voucher_content.png" alt="" class="voucher_ad__content__img" @click="handleClaim">
      <img src="@@/assets/img/smt/activity/smt_voucher_close.png" alt="" class="voucher_ad__content__close" @click="handleClose">
    </div>
  </div>
</template>

<script>
import CONFIG from '@@/config'
import { mapGetters } from 'vuex'
import { isLogin, isSmtSite } from '@@/utils/is'
import { sensorsTrack } from '@@/utils/sensors'
import { getSmtNewUserVoucherPopup, claimSmtNewUserVoucher } from '@@/api/pcba'

let storageKey = 'SMT_VOUCHER_AD_CLOSE_TIME_KEY'

export default {
  data() {
    return {
      isShow: false,
      isClaim: false
    }
  },
  computed:{
    // 用户信息
    ...mapGetters('orderUser', [
      'userInfo',
    ]),
  },
  created() {
    if (isSmtSite) {
      const timer = setInterval(() => {
        if (this.userInfo.feGetInfoEnd) {
          clearInterval(timer)
          storageKey = `SMT_VOUCHER_AD_CLOSE_TIME_KEY_${this.userInfo.sso_uid}`
          this.getSmtVoucherPopup()
        }
      }, 500)
    }
  },
  methods: {
    // 计算是否间隔7天
    isInterval7Days() {
      // 用户关闭弹窗后，7 天内不再展示本期活动弹窗
      const closeTimeStr = localStorage.getItem(storageKey)
      if (closeTimeStr) {
        // 已领取后关闭
        if (closeTimeStr == 'none') return

        const closeDate = new Date(closeTimeStr)
        const now = new Date()
        closeDate.setHours(0, 0, 0, 0)
        now.setHours(0, 0, 0, 0)
        const diffDays = (now.getTime() - closeDate.getTime()) / (1000 * 60 * 60 * 24)
        if (diffDays < 7) {
          return false
        }
      }
      return true
    },
    getSmtVoucherPopup() {
      const isInterval7Days = this.isInterval7Days()
      if (!isInterval7Days) return

      getSmtNewUserVoucherPopup().then(res => {
        if (res.retCode === 0 && res.result.needPopup) {
          this.isShow = true
          sensorsTrack('smt_new_coupon_popup_exposure', { entrance: '弹窗成功展示' })
        }
      })
    },
    // 领取现金券
    handleClaim() {
      sensorsTrack('smt_new_coupon_popup_click_receive', { entrance: '用户点击“立即领取”' })
      claimSmtNewUserVoucher()
        .then(res => {
          if (res.retCode === 0) {
            this.isClaim = true
            sensorsTrack('smt_new_coupon_receive_success', { entrance: '领券成功' })
          } else {
            this.isShow = false
            this.$message.error('现金券领取失败，请稍后重试或者联系您的客服经理')
            sensorsTrack('smt_new_coupon_receive_fail', { entrance: '领券失败' })
          }
        })
    },
    // 关闭弹窗
    handleClose() {
      const date = new Date()
      const toDayTimeStr = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
      localStorage.setItem(storageKey, toDayTimeStr)
      this.isShow = false
      sensorsTrack('smt_new_coupon_popup_close', { entrance: '用户点击关闭' })
    },
    handleCloseNone() {
      localStorage.setItem(storageKey, 'none')
      this.isShow = false
    },
    handleQuoteSmt() {
      this.handleCloseNone()
      sensorsTrack('smt_new_coupon_jump_quote', { entrance: '领取成功点击“去下SMT订单”' })
    },
    handleViewVoucher() {
      this.handleCloseNone()
      window.open(`${CONFIG.HQCHIP_HOST}/mycenter/finance/voucher`)
      sensorsTrack('smt_new_coupon_jump_list', { entrance: '领取成功点击“查看我的现金券”' })
    }
  }
}
</script>

<style lang="scss" scoped>
.voucher_ad {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  user-select: none;

  &__content {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 25vw;
    transform: translate(-50%, -50%);
    z-index: 9999;
    cursor: pointer;

    &__img {
      display: block;
      width: 100%;
    }

    &__btn {
      position: absolute;
      bottom: 99px;
      left: 62px;
      cursor: pointer;
      animation: btn-scale-pulse 1.5s ease-in-out infinite;
    }

    &__close {
      position: absolute;
      bottom: -60px;
      left: 50%;
      display: block;
      width: 45px;
      height: 45px;
      transform: translateX(-50%);
      cursor: pointer;
    }
  }

  &__claimed {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9999;
    box-sizing: border-box;
    padding: 16px;
    width: 400px;
    height: 260px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0px 2px 12px 0px rgba(80, 107, 138, 0.10);

    &__close {
      display: flex;
      justify-content: flex-end;
      cursor: pointer;
    }

    &__success {
      display: flex;
      justify-content: center;
    }

    &__text {
      margin: 16px 0 8px;
      font-size: 16px;
      font-weight: 700;
      color: #333333;
      line-height: 22px;
      text-align: center;
    }

    &__desc {
      font-size: 12px;
      color: #666666;
      text-align: center;
      margin-bottom: 24px;
    }

    &__btns {
      display: flex;
      justify-content: center;
      margin-top: 16px;

      span {
        display: block;
        margin: 0 8px;
        width: 160px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 16px;
        border-radius: 4px;

        &.secondary-btn {
          color: #333333;
          background-color: #F4F6F9;

          &:hover {
            background-color: #E8EAEC;
          }
        }

        &.primary-btn {
          color: #FFFFFF;
          background-color: #CC0000;

          &:hover {
            background-color: #DB1A1A;
          }
        }
      }
    }
  }
}

@keyframes btn-scale-pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}
</style>